import type React from 'react';
import {
  Button as CButton,
  Spacer as ChakraSpacer,
  Divider,
  Text,
  VStack,
  Box,
} from '@chakra-ui/react';
import { useHomePageColors } from '@/hooks/useHomePageColors';
import PlaceTeamsSection from './PlaceTeamsSection';
import { HomeHeading } from './HomeHeading';
import { HomeJoinLeaguePreview } from './HomeJoinLeaguePreview';

type JoinLeagueSectionProps = {
  onClickCTA: () => void;
};

const JoinLeagueSection: React.FC<JoinLeagueSectionProps> = (props) => {
  const { surfaceMuted, divider, brandAccent, onAccent } = useHomePageColors();

  return (
    <VStack py='36px' bgColor={surfaceMuted} borderRadius='8px' justifyContent='center' width='full'>
      <PlaceTeamsSection />
      <Box
        px={{
          base: '1em',
          sm: '2em',
          md: '24px',
        }}
        maxW='full'
        m='auto'
        w='full'
      >
        <Divider my={4} maxW='container.lg' borderColor={divider} />
        <VStack gap={0} pb={4} w='full'>
          <HomeHeading
            fontWeight={700}
            w={{
              base: '70%',
              md: '100%',
              lg: '100%',
              xl: '100%',
            }}
          >
            3. Join a League. Create Your Own.
          </HomeHeading>
          <Text
            textAlign='center'
            fontFamily='Montserrat'
            opacity={0.6}
            fontWeight={400}
            fontSize={{
              base: '14px',
              md: '15px',
              lg: '18px',
              xl: '20px',
            }}
            w={{
              base: '70%',
              lg: '100%',
              xl: '100%',
            }}
          >
            Compete with Friends, Family and Colleagues
          </Text>
        </VStack>
        <HomeJoinLeaguePreview />
        <ChakraSpacer mt={{ base: '2rem', md: '3rem' }} />
        <VStack gap={6}>
          <HomeHeading
            fontWeight={700}
            w={{
              base: '80%',
              md: '100%',
            }}
            fontSize={{
              base: '18px',
              md: '20px',
              lg: '24px',
              xl: '28px',
            }}
          >
            Every Game Matters. Create Your List Now!
          </HomeHeading>
          <CButton
            bgColor={brandAccent}
            borderRadius='full'
            width='fit-content'
            color={onAccent}
            fontSize={{
              base: '14px',
              sm: '16px',
              md: '18px',
            }}
            px={{
              base: '22px',
              sm: '32px',
              md: '48px',
              lg: '64px',
              xl: '80px',
            }}
            py={{
              base: '8px',
              sm: '12px',
              md: '16px',
              lg: '24px',
              xl: '32px',
            }}
            zIndex={1}
            onClick={props.onClickCTA}
            _hover={{ filter: 'brightness(0.92)' }}
          >
            Create Your List
          </CButton>
        </VStack>
      </Box>
    </VStack>
  );
};

export default JoinLeagueSection;
